class RecentSearches extends HTMLElement {
  constructor() {
    super();
    this.savedData = localStorage.getItem('searchTerms');
  }

  connectedCallback() {
    this.renderData();
  }

  renderData() {
    const searchTerms = JSON.parse(this.savedData) || [];
    if (searchTerms.length) {
      const containerDiv = document.createElement('div');
      containerDiv.className = 'tw-overflow-x-scroll tw-w-[600px] [scrollbar-width:none]';
      const ul = document.createElement('ul');
      ul.className = 'recent-searches-list lmd:tw-w-[70%] tw-w-max';

      searchTerms.forEach((term) => {
        const li = document.createElement('li');
        li.textContent = term;
        li.className = 'recent-search-item focus-inset';
        li.setAttribute('tabindex', '0');
        li.addEventListener('click', () => {
          const searchUrl = `search?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
          window.location.href = searchUrl;
        });
        ul.appendChild(li);
      });

      containerDiv.appendChild(ul);
      this.appendChild(containerDiv);
    } else {
      const hideRecent = document.getElementsByClassName('container-recent-search');
      for (let i = 0; i < hideRecent.length; i++) {
        hideRecent[i].style.display = 'none';
      }
    }
  }
}
customElements.define('recent-searches', RecentSearches);

class PerformSearches extends HTMLElement {
  constructor() {
    super();
    this.savedData = localStorage.getItem('recently_searches');
    this.query = document.querySelector('.custom-at-search').dataset.query;
  }

  connectedCallback() {
    this.setRecentSearches();
  }

  setRecentSearches() {
    let searchTerms = JSON.parse(localStorage.getItem('searchTerms')) || [];

    if (this.query !== '') {
      searchTerms.push(this.query);
      let filteredArray = searchTerms.filter((item, index) => searchTerms.lastIndexOf(item) === index);

      if (filteredArray.length > 6) {
        filteredArray = filteredArray.slice(-6);
      }

      localStorage.setItem('searchTerms', JSON.stringify(filteredArray));
    }
  }
}
customElements.define('perform-recent-searches', PerformSearches);